import React, { useState, Fragment, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatch } from "store";
import sessionAmount from "assets/images/grey-wallet.png";
import whiteWallet from "assets/images/white-wallet.png";
import {
  Container,
  CardContainer,
  TabeContainer,
  TabeCart,
  StatusTabeContainer,
  Status,
  FeaturedRow,
  FeaturedBadge,
} from "./styled";

import {
  setChefActiveButton,
  setChefStatusActiveButton,
} from "store/user-slice";
import PlaceholderImage from "assets/images/place-img.png";
import Pagination from "components/particles/pagination/pagination";
import NoDataFound from "components/particles/no-data-found";
import Button from "components/particles/primary-button";

import user from "assets/images/chef-user.svg";
import chefLocation from "assets/images/chef-location.svg";
import bag from "assets/images/chef-bag.svg";
import lang from "assets/images/language.svg";
import demote from "assets/images/demote.png";

import sessionDarkIcon from "assets/images/session-dark-icon.svg";
import sessionIcon from "assets/images/session-white-icon.svg";
import dishesIcon from "assets/images/dishes-icon.svg";
import dishesDarkIcon from "assets/images/dishes-dark-icon.svg";
import reviewsIcon from "assets/images/reviews-white-icon.svg";

import reviewsDarkIcon from "assets/images/reviews-dark-icon.svg";
import premium from "assets/images/premium.svg";
import view from "assets/images/view-icon.svg";
import { siteRoutes } from "utils/helpers/enums/routes.enums";

import StatusTabe from "components/particles/status-tabe";
import { useHomeChefById } from "./useHook";
import { useForm } from "react-hook-form";
import {
  HomeChefViewReceipeSearchDTO,
  HomeChefViewSessionSearchDTO,
} from "utils/helpers/models/homeChef.dto";
import ReviewsHome from "./reviews";
import PromoteHomeCookModal from "components/popus/PromotoHomeCook";
import Wallets from "./wallets";

const HomeChefView: React.FC = () => {
  const [prevData, setPrevData] = useState<any>(null);
  const location = useLocation();
  const { state } = location;


  useEffect(() => {
    if (location.state) {
      setPrevData(location.state.chef);
    }
  }, [location.state]);

  const { isLoading } = useSelector((state: any) => state.user);
  const navigate = useNavigate();

  const { chefActiveButton, chefStatusActiveButton } = useSelector(
    (state: any) => state.user
  );
  const { getHomeChefById, getDishesById, getSessionById, getFeaturedDish } =
    useHomeChefById();
  const [data, setData] = useState<any[]>();
  const [dishData, setDishData] = useState<any[]>();
  const [sessionData, setSessionData] = useState<any[]>();
  const [featuredDishData, setFeaturedDishData] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [action, setAction] = useState<"promote" | "demote" | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [sessionPagintaionState, setSessionPaginationState] = useState<any>();
  const [dishesPagintaionState, setDishesPaginationState] = useState<any>();
  const [filters, setFilters] = useState<Partial<HomeChefViewReceipeSearchDTO | HomeChefViewSessionSearchDTO>>({});

  const {
    register,
    handleSubmit,
    setValue,
    reset: formReset,
  } = useForm<HomeChefViewReceipeSearchDTO | HomeChefViewSessionSearchDTO>();

  const handleViewPage = (sessionId: string) => {
    navigate(siteRoutes.homeChefViewDetail, { state: { sessionId } });
  };

  const limit = 10;
  const offset = 0;

  const isFeaturedDish = (dishId: number): boolean => {
    if (!featuredDishData) return false;
    if (Array.isArray(featuredDishData)) {
      return featuredDishData.some((dish: any) => dish?.dishId === dishId);
    }
    return featuredDishData?.dishId === dishId;
  };

  const mergeDishesWithFeatured = (regularDishes: any[], featuredDish: any, offset: number = 0) => {
    const regularArray = Array.isArray(regularDishes) ? regularDishes : [];

    if (offset !== 0 || !featuredDish) {
      return regularArray;
    }

    let featuredArray: any[] = [];
    if (Array.isArray(featuredDish)) {
      featuredArray = featuredDish;
    } else if (featuredDish && typeof featuredDish === 'object') {
      featuredArray = [featuredDish];
    }

    const regularDishIds = new Set(regularArray.map((dish: any) => dish.dishId));

    const uniqueFeaturedDishes = featuredArray.filter(
      (dish: any) => dish && dish.dishId && !regularDishIds.has(dish.dishId)
    );

    return [...uniqueFeaturedDishes, ...regularArray];
  };

  const upgradePremium = () => {
    setAction("promote");
    setIsModalOpen(true);
  };
  useEffect(() => {
    dispatch(setChefActiveButton("Session"));
  }, []);

  const demoteHomeCook = () => {
    setAction("demote");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setAction(null);
    setRefreshKey((prev) => prev + 1);
  };

  const fetchNextRecords = (offset: number) => {
    const statusFilter =
      chefStatusActiveButton === "All" ? "" : chefStatusActiveButton;

    if (chefActiveButton === "Session") {
      getSessionById(
        state.id,
        statusFilter,
        setSessionData,
        filters.createdAt || "",
        filters.name || "",
        filters.users || "",
        setSessionPaginationState,
        limit,
        offset
      );
    } else if (chefActiveButton === "Recipes") {
      getDishesById(
        state.id,
        filters.dishName || "",
        filters.dietaries || "",
        filters.state || "",
        (regularDishes: any[]) => {
          if (offset === 0) {
            setDishData(regularDishes);
            getFeaturedDish(state.id, (featuredDish: any) => {
              setFeaturedDishData(featuredDish);
              const mergedDishes = mergeDishesWithFeatured(regularDishes, featuredDish, offset);
              setDishData(mergedDishes);
            });
          } else {
            setDishData(regularDishes);
          }
        },
        setDishesPaginationState,
        limit,
        offset
      );
    }

    const toTopElement = document.getElementById("toTop");
    if (toTopElement) {
      toTopElement.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    if (state?.id) {
      getHomeChefById(state.id, setData, offset, limit);
    }
  }, [state?.id, refreshKey]);

  useEffect(() => {
    if (state?.id) {
      const status = state?.status;
      const dishName = state?.dishName;
      const createdOn = state?.createdOn;
      const homeCookName = state?.homeCookName;
      getSessionById(
        state.id,
        status,
        setSessionData,
        createdOn,
        dishName,
        homeCookName,
        setSessionPaginationState,
        limit,
        offset
      );
    }
  }, [state?.id]);

  function onStatusChange(type: string, id: string, status: string) {
    if (type === "Session") {
      getSessionById(
        state.id,
        status,
        setSessionData,
        "",
        "",
        "",
        setSessionPaginationState,
        limit,
        offset
      );
    }
  }

  useEffect(() => {
    if (state?.id) {
      const dishName = state?.dishName;
      const userDietaryChoice = state?.userDietaryChoice;
      const userState = state?.userState;
      getDishesById(
        state.id,
        dishName,
        userDietaryChoice,
        userState,
        (regularDishes: any[]) => {
          setDishData(regularDishes);
          getFeaturedDish(state.id, (featuredDish: any) => {
            setFeaturedDishData(featuredDish);
            const mergedDishes = mergeDishesWithFeatured(regularDishes, featuredDish, offset);
            setDishData(mergedDishes);
          });
        },
        setDishesPaginationState
      );
    }
  }, [state?.id]);


  const search = (
    dataa: HomeChefViewReceipeSearchDTO | HomeChefViewSessionSearchDTO
  ) => {
    const statusFilter =
      chefStatusActiveButton === "All" ? "" : chefStatusActiveButton;

    setFilters(dataa);

    if (chefActiveButton === "Session") {
      getSessionById(
        state.id,
        statusFilter,
        setSessionData,
        dataa.createdAt || "",
        dataa.name || "",
        dataa.users || "",
        setSessionPaginationState,
        limit,
        offset
      );
    } else if (chefActiveButton === "Recipes") {
      getDishesById(
        state.id,
        dataa.dishName || "",
        dataa.dietaries || "",
        dataa.state || "",
        (regularDishes: any[]) => {
          setDishData(regularDishes);
          getFeaturedDish(state.id, (featuredDish: any) => {
            setFeaturedDishData(featuredDish);
            const mergedDishes = mergeDishesWithFeatured(regularDishes, featuredDish, offset);
            setDishData(mergedDishes);
          });
        },
        setDishesPaginationState,
        limit,
        offset
      );
    }
  };

  const handleReset = () => {
    setValue("name", "");
    setValue("createdAt", "");
    setValue("users", "");
    setValue("dishName", "");
    setValue("dietaries", "");
    setValue("state", "");
    setValue("status", "");
    setValue("homeCookName", "");
    formReset();

    if (chefActiveButton === "Session") {
      getSessionById(
        state.id,
        chefStatusActiveButton === "All" ? "" : chefStatusActiveButton,
        setSessionData,
        "",
        "",
        "",
        setSessionPaginationState,
        limit,
        offset
      );
    }
    else if (chefActiveButton === "Recipes") {
      getDishesById(
        state.id,
        "",
        "",
        "",
        (regularDishes: any[]) => {
          setDishData(regularDishes);
          getFeaturedDish(state.id, (featuredDish: any) => {
            setFeaturedDishData(featuredDish);
            const mergedDishes = mergeDishesWithFeatured(regularDishes, featuredDish, offset);
            setDishData(mergedDishes);
          });
        },
        setDishesPaginationState,
        limit,
        offset
      );
    }
  };

  useEffect(() => {
    dispatch(setChefStatusActiveButton("All"));
  }, []);


  return (
    <Container id="toTop">
      <div className="title">
        <h1>Home Cook</h1>
        <div>
          {data?.[0]?.premiumHomeCook ? (
            <button onClick={demoteHomeCook}>
              <img src={demote} alt="img" />
              <p>Demote HomeCook</p>
            </button>
          ) : (
            <button onClick={upgradePremium}>
              <img src={premium} alt="img" />
              <p>Upgrade as Premium</p>
            </button>
          )}
        </div>
      </div>

      <CardContainer>
        {(data && data.length > 0
          ? data
          : prevData
            ? [prevData]
            : []
        ).map((item, index) => (
          <Fragment key={index}>
            <div className="user-profile">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <img
                    src={
                      item.image
                        ? item.image
                        : prevData?.image
                          ? prevData.image
                          : PlaceholderImage

                    }
                    alt="img"
                    style={{ width: "100px", height: "100px" }}
                  />
                  <div className="user-detail">
                    <h1>{item.name ? item.name : "-"}</h1>
                    <p>
                      {item.premiumHomeCook
                        ? "Premium Home Cook"
                        : "Standard Home Cook"}
                    </p>
                  </div>
                </div>
                <div>
                  <div className="info-detail">
                    <div>
                      <p>Dishes</p>
                      <h1>{item.totalDishes ? item.totalDishes : 0}</h1>
                    </div>
                    <div>
                      <p>Following</p>
                      <h1>{item.totalFollowers ? item.totalFollowers : 0}</h1>
                    </div>
                    <div>
                      <p>Rating</p>
                      <h1>{item.homeCookAverageRating ? item.homeCookAverageRating : 0}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="user-info">
              <div className="info-row">
                <img src={bag} alt="calendar" />
                <p>{item.profession ? item.profession : "-"}</p>
              </div>

              <div className="info-row">
                <img src={lang} alt="language" />
                <p>
                  {item.language
                    ? Array.isArray(item.language)
                      ? item.language.join(", ")
                      : item.language
                    : "English"}
                </p>
              </div>

              <div className="info-row">
                <img src={chefLocation} alt="location" />
                <p>{item.address ? item.address : "-"}</p>
              </div>

              <div className="info-row">
                <img src={user} alt="bio" />
                <p>
                  {item.bio
                    ? item.bio
                    : "-"}
                </p>
              </div>
            </div>

          </Fragment>
        ))}
      </CardContainer>


      <TabeContainer>
        <TabeCart
          active={chefActiveButton === "Session"}
          onClick={() => dispatch(setChefActiveButton("Session"))}
        >
          <div className="categories-tab-img">
            <img
              src={
                chefActiveButton === "Session" ? sessionIcon : sessionDarkIcon
              }
              alt="img"
            />
          </div>
          <h1>Session</h1>
        </TabeCart>
        <TabeCart
          active={chefActiveButton === "Recipes"}
          onClick={() => dispatch(setChefActiveButton("Recipes"))}
        >
          <div className="categories-tab-img">
            <img
              src={chefActiveButton === "Recipes" ? dishesIcon : dishesDarkIcon}
              alt="img"
            />
          </div>
          <h1>Dishes</h1>
        </TabeCart>
        <TabeCart
          active={chefActiveButton === "Reviews"}
          onClick={() => dispatch(setChefActiveButton("Reviews"))}
        >
          <div className="categories-tab-img">
            <img
              src={
                chefActiveButton === "Reviews" ? reviewsIcon : reviewsDarkIcon
              }
              alt="img"
            />
          </div>
          <h1>Reviews</h1>
        </TabeCart>
        <TabeCart
          active={chefActiveButton === "Wallets"}
          onClick={() => dispatch(setChefActiveButton("Wallets"))}
        >
          <div className="categories-tab-img">
            <img
              src={
                chefActiveButton === "Wallets" ? whiteWallet : sessionAmount
              }
              alt="img"
            />
          </div>
          <h1>Wallets</h1>
        </TabeCart>
      </TabeContainer>

      {chefActiveButton === "Session" && (

        <StatusTabeContainer>
          {chefActiveButton === "Session" && (
            <>
              <StatusTabe
                active={chefStatusActiveButton === "All"}
                onclick={() => {
                  onStatusChange("Session", state.id, "");
                  dispatch(setChefStatusActiveButton("All"));
                }}
                title={"All"}
              />
              <StatusTabe
                active={chefStatusActiveButton === "incoming"}
                onclick={() => {
                  onStatusChange("Session", state.id, "incoming");
                  dispatch(setChefStatusActiveButton("incoming"));
                }}
                title={"Incoming"}
              />
              <StatusTabe
                active={chefStatusActiveButton === "readyToPay"}
                onclick={() => {
                  onStatusChange("Session", state.id, "readyToPay");
                  dispatch(setChefStatusActiveButton("readyToPay"));
                }}
                title={"Pending Payment"}
              />
              <StatusTabe
                active={chefStatusActiveButton === "inProcess"}
                onclick={() => {
                  onStatusChange("Session", state.id, "inProcess");
                  dispatch(setChefStatusActiveButton("inProcess"));
                }}
                title={"Paid"}
              />
              <StatusTabe
                active={chefStatusActiveButton === "active"}
                onclick={() => {
                  onStatusChange("Session", state.id, "active");
                  dispatch(setChefStatusActiveButton("active"));
                }}
                title={"Active"}
              />
              <StatusTabe
                active={chefStatusActiveButton === "completed"}
                onclick={() => {
                  onStatusChange("Session", state.id, "completed");
                  dispatch(setChefStatusActiveButton("completed"));
                }}
                title={"Completed"}
              />
              <StatusTabe
                active={chefStatusActiveButton === "rejected"}
                onclick={() => {
                  onStatusChange("Session", state.id, "rejected");
                  dispatch(setChefStatusActiveButton("rejected"));
                }}
                title={"Rejected"}
              />
              <StatusTabe
                active={chefStatusActiveButton === "expired"}
                onclick={() => {
                  onStatusChange("Session", state.id, "expired");
                  dispatch(setChefStatusActiveButton("expired"));
                }}
                title={"Expired"}
              />
            </>
          )}
        </StatusTabeContainer>
      )}

      {chefActiveButton === "Session" ? (
        <div className="search-container">
          <div className="input-fields">
            <input
              type="text"
              placeholder="Search by Dish Name"
              {...register("name")}
            />
            <div className="custom-date-input-container">
              <input
                type="date"
                className="custom-date-input"
                placeholder="Search by Date"
                {...register("createdAt")}
              />
            </div>
            <input
              type="text"
              placeholder="Search by Users"
              {...register("users")}
            />
          </div>
          <div className="button-fields">
            <Button
              title="Search"
              width="16rem"
              fill="true"
              onclick={handleSubmit(search)}
            />
            <Button
              title="Reset"
              width="16rem"
              fill="true"
              backgroundcolor="var(--reset-button)"
              onclick={handleReset}
            />
          </div>
        </div>
      ) : chefActiveButton === "Recipes" ? (
        <div className="search-container">
          <div className="input-fields">
            <input
              type="text"
              placeholder="Search By Dish Name"
              {...register("dishName")}
            />
            <input
              type="text"
              placeholder="Search By Dietary Name"
              {...register("dietaries")}
            />
            <input
              type="text"
              placeholder="Search By State"
              {...register("state")}
            />
          </div>
          <div className="button-fields">
            <Button
              title="Search"
              width="16rem"
              fill="true"
              onclick={handleSubmit(search)}
            />
            <Button
              title="Reset"
              width="16rem"
              fill="true"
              backgroundcolor="var(--reset-button)"
              onclick={handleReset}
            />
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="data-table">
        {chefActiveButton === "Session" && (
          <div className="data-table">
            <table>
              <thead>
                <tr>
                  <th>Dish</th>
                  <th>Date</th>
                  <th className="th">Amount</th>
                  <th>Username</th>
                  {chefStatusActiveButton === "All" ||
                    chefStatusActiveButton === "Complete" ? (
                    <th className="th">Rating</th>
                  ) : null}
                  {chefStatusActiveButton === "All" ? (
                    <th className="th">Status</th>
                  ) : null}
                  <th className="th">Actions</th>
                </tr>
              </thead>
              <tbody>
                {sessionData && sessionData.length > 0 ? (
                  sessionData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={
                              item.dish.coverImage[0] ||
                              "https://picsum.photos/200"
                            }
                            alt="img"
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                            }}
                          />{" "}
                          {item.dish.dishName}
                        </div>
                      </td>
                      <td>
                        {new Date(
                          item.sessionDetails.sessionDate
                        ).toLocaleDateString("en-US")}
                      </td>

                      <td className="th">
                        ${item.sessionDetails.sessionAmount}
                      </td>
                      <td>{item?.user?.userName || "--"}</td>
                      {chefStatusActiveButton === "All" ||
                        chefStatusActiveButton === "Complete" ? (
                        <td className="th">
                          {item.sessionDetails.sessionRating || "-"}
                        </td>
                      ) : null}
                      {chefStatusActiveButton === "All" ? (
                        <td className="th">
                          <Status active={item.status}>
                            {item.sessionDetails.sessionStatus
                              .charAt(0)
                              .toUpperCase() +
                              item.sessionDetails.sessionStatus.slice(1)}
                          </Status>
                        </td>
                      ) : null}
                      <td className="actions th">
                        <div
                          className="view-container"
                          onClick={() => handleViewPage(item.sessionId)}
                        >
                          <img src={view} alt="img" />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound isShow={!isLoading} />
                )}
              </tbody>
            </table>
          </div>
        )}
        <div className="data-table">
          {chefActiveButton === "Recipes" && (
            <table>
              <thead>
                <tr>
                  <th>Dish</th>
                  <th className="th">Serving size</th>
                  <th className="th">Prep Time</th>
                  <th>Dietary</th>
                  <th className="th">State</th>
                  <th className="th">Ingredients</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {dishData && dishData.length > 0 ? (
                  dishData.map((item, index) => {
                    const isFeatured = isFeaturedDish(item.dishId);
                    return (
                      <FeaturedRow key={index} isFeatured={isFeatured}>
                        <td>
                          <div style={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "14px",
                            alignItems: "center",
                          }}>
                            <img
                              src={
                                item.coverImage[0] || "https://picsum.photos/200"
                              }
                              alt="Dish"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                              }}
                            />{" "}
                            <span>{item.name}</span>
                            {isFeatured && <FeaturedBadge>Featured</FeaturedBadge>}
                          </div>
                        </td>
                        <td className="th">{item.serving}</td>
                        <td className="th">{item.preparationTime}</td>
                        <td>
                          {Array.isArray(item.dietaries)
                            ? `${item.dietaries
                              .slice(0, 2)
                              .map((dietary: any) => dietary.dietaryName)
                              .join(", ")}${item.dietaries.length > 2 ? " ..." : ""
                            }`
                            : ""}
                        </td>
                        <td className="th">{item.state}</td>
                        <td className="th">{item.ingredientCount}</td>
                        <td className="actions th">
                          <div
                            className="view-container"
                            onClick={() => {
                              const featured = isFeaturedDish(item.dishId);
                              if (featured) {
                                navigate(siteRoutes.homeChefViewReceipe, {
                                  state: { 
                                    useFeaturedApi: true,
                                    homeCookId: state.id 
                                  },
                                });
                              } else {
                                navigate(siteRoutes.homeChefViewReceipe, {
                                  state: { dishId: item.dishId },
                                });
                              }
                            }}
                          >
                            <img src={view} alt="img" />
                          </div>
                        </td>
                      </FeaturedRow>
                    );
                  })
                ) : (
                  <NoDataFound isShow={!isLoading} />
                )}
              </tbody>
            </table>
          )}
        </div>

        {chefActiveButton === "Reviews" && (
          <ReviewsHome homeCookId={state?.id} />
        )}

        {chefActiveButton === "Wallets" && (
          <Wallets homeCookId={state?.id} />

        )}
      </div>
      {chefActiveButton !== "Reviews" && chefActiveButton !== "Wallets" && (
        <Fragment>
          <Pagination
            totalRecords={
              chefActiveButton === "Session"
                ? sessionPagintaionState?.totalSessions
                : dishesPagintaionState?.totalDishes
            }
            perPage={limit}
            handleFetchNextRecords={fetchNextRecords}
          />
        </Fragment>
      )}
      <PromoteHomeCookModal
        isOpen={isModalOpen}
        action={action}
        onClose={closeModal}
        homeCookId={state?.id}
      />
    </Container>
  );
};

export default HomeChefView;
